<template>
    <div class="mt-1 custom-field__bg" :class="[{'custom-field__height':props.planPermission === false && (!customFieldList || customFieldList?.filter((val)=>(val?.isDelete) && (val?.global || val?.projectId === props?.task?.ProjectID))?.length < 3)}]">
        <div v-if="!props.hideHeader" class="d-flex align-items-center justify-content-between">
            <h4 :class="{'font-size-16 font-weight-600' : clientWidth <=767 , 'font-size-14 font-weight-700' : clientWidth > 767 }">{{$t('CustomField.custom_field')}}</h4>
            <h4 v-if="props.editPermission === true" class="font-roboto-sans font-size-14 font-weight-500 font-normal text-decoration-underline blue cursor-pointer" @click="emit('isCustomField',true)">+ {{$t('CustomField.custom_field')}}</h4>
        </div>
        <template v-if="visibleCustomFieldList && visibleCustomFieldList.length">
            <template v-for="(item, index) in visibleCustomFieldList" :key="index">
                <div class="position-re" :class="[{'pointer-event-none':props.editPermission === false}]">
                    <component
                        :is="getView(item?.fieldType)"
                        @inputUpdate="(val)=> item.fieldValue = val"
                        @blurUpdate="handleEmit"
                        :detail="item"
                        @handleEdit="handleEdit(item)"
                        @handleUpdate="handleUpdate"
                    />
                </div>
            </template>
        </template>
    </div>
</template>

<script setup>
    import { useStore } from 'vuex';
    import { computed,watch,onMounted, inject } from 'vue';
    import TextComponentListing from '../../atom/customFieldTaskView/textComponentListing.vue'
    import CheckboxComponentListing from '../../atom/customFieldTaskView/checkboxComponentListing.vue'
    import DropdownComponentListing from '../../atom/customFieldTaskView/dropdownComponentListing.vue'
    import DateComponentListing from '../../atom/customFieldTaskView/dateComponentListing.vue'
    import MoneyComponentListing from '../../atom/customFieldTaskView/moneyComponentListing.vue'
    import TextareaComponentListing from '../../atom/customFieldTaskView/textareaComponentListing.vue'
    import NumberComponentListing from '../../atom/customFieldTaskView/numberComponentListing.vue'
    import EmailComponentListing from '../../atom/customFieldTaskView/emailComponentListing.vue'
    import PhoneComponentListing from '../../atom/customFieldTaskView/phoneComponentListing.vue'


    const { getters } = useStore();
    const customFieldList = computed(() => (getters['settings/finalCustomFields'] && getters['settings/finalCustomFields'].length) ? getters['settings/finalCustomFields']: []);
    const props = defineProps({
        task:{
            type:Object,
            default:()=>{}
        },
        editPermission:{
            type: [Boolean, Number],
            default: false
        },
        planPermission:{
            type: [Boolean, Number],
            default:false
        },
        hideHeader: {
            type: Boolean,
            default: false
        }
    })
    const emit = defineEmits(['blurUpdate','isCustomField','editCustomField']);
    const clientWidth = inject("$clientWidth");
    const normalizeFieldLabel = (value = "") => String(value)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();
    const isHiddenTaskField = (item = {}) => {
        const fieldTitle = normalizeFieldLabel(item.fieldTitle || item.name || item.label || "");
        const fieldCode = normalizeFieldLabel(item.fieldCode || item.key || item.code || "");
        return fieldTitle === "ma thuoc tinh" || fieldCode === "taskkey";
    };
    const visibleCustomFieldList = computed(() => customFieldList.value?.filter((val) => {
        return val?.isDelete &&
            val?.type === 'task' &&
            (val?.global || val?.projectId?.includes(props?.task?.ProjectID)) &&
            !isHiddenTaskField(val);
    }) || []);
    // watch
    watch(() => getters['settings/finalCustomFields'],(val) => {
        customFieldList.value = val;
        manageCustomField(customFieldList.value);
    });

    //onMounted
    onMounted(()=>{
        manageCustomField(customFieldList.value);
    });
    // function
    const manageCustomField = (data) => {
        if (!(data && data.length)) {
            return;
        }
        if(props.task && props.task?.customField && Object.keys(props.task?.customField)?.length){
            customFieldList.value.forEach((val,index)=>{
                if(props.task?.customField[val._id]){
                    customFieldList.value[index] = {
                        ...val,
                        fieldValue:props.task?.customField[val._id]?.fieldValue,
                        fieldCode:props.task?.customField[val._id]?.fieldCode || '',
                        fieldPattern:props.task?.customField[val._id]?.fieldPattern || '',
                        fieldFlag:props.task?.customField[val._id]?.fieldFlag || ''
                    };
                }else{
                    delete val?.fieldValue
                    delete val?.fieldCode
                    delete val?.fieldPattern
                    delete val?.fieldFlag
                    customFieldList.value[index] = val;
                }
            });
        }else{
            if(data && data.length){
                data.forEach((val)=>{
                    delete val?.fieldValue;
                    delete val?.fieldCode;
                    delete val?.fieldPattern;
                    delete val?.fieldFlag;
                });
            }
            customFieldList.value = data;
        }
    };

    const handleEdit = (val) => {
        emit("editCustomField",val);
    };
    const handleUpdate = (value,detail,id) => {
        emit('blurUpdate',value,detail,id,true);
    };

    const getView = (val) => {
        switch(val){
            case 'text':
                return TextComponentListing
            case 'checkbox':
                return CheckboxComponentListing
            case 'dropdown':
                return DropdownComponentListing
            case 'date':
                return DateComponentListing
            case 'money':
                return MoneyComponentListing
            case 'textarea':
                return TextareaComponentListing
            case 'number':
                return NumberComponentListing
            case 'email':
                return EmailComponentListing
            case 'phone':
                return PhoneComponentListing
        }
    };

    const handleEmit = (value,detail,id) => {
        if(value && detail?.fieldType === 'phone'){
            let index = customFieldList.value.findIndex((x)=>x._id === detail._id);
            if(index > -1){
                customFieldList.value[index].fieldValue = value;
                detail.fieldValue = value;
            }
        }
        emit('blurUpdate',value,detail,id);
    };
</script>
<style>
    @import './style.css';
</style>
